/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
//Import Breadcrumb
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { DetailBackButton } from '../../Components/Common/Detail';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  Tooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Form,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
} from 'reactstrap';

import { Alert, UncontrolledAlert } from 'reactstrap';
import Select from 'react-select';
import classnames from 'classnames';
import { orderSummary } from '../../common/data/ecommerce';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { isNumericOnly } from '../../utils/validators';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id';
import { incoTermTable, deliveryUnit } from '../../common/data';
import ActionMenu from './ActionMenu';
import HpsRequestTab from './HpsRequestTab';
import { useParams, useNavigate } from 'react-router-dom';
registerLocale('id', id); // Bahasa Indonesia
import axios from 'axios';
import { api, web } from '../../config';
import notify, { MESSAGES } from '../../utils/notify';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import { convertToInputDateFormat } from '../../utils/dateformatter';
import { format } from 'date-fns';

const HpsForm = () => {
  const token = getAuthToken();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountry, setselectedCountry] = useState(null);
  const [selectedState, setselectedState] = useState(null);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [modal, setModal] = useState(false);
  const [modalincoterm, setModalIncoterm] = useState(false);
  const [modalpricing, setModalPricing] = useState(false);
  const [deletemodal, setDeleteModal] = useState(false);
  const [value, setValue] = useState('0');
  const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(null); // from
  const [endDate, setEndDate] = useState(null); // to
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [ids] = useState(useParams().id);
  const navigate = useNavigate();
  const [qtyDeliveryData, setQtyDeliveryData] = useState({ items: [] });

  const LoadDefault = () => {
    fetchDataProcurement(ids, setForm, token);
  };

  // const [form, setForm] = useState({
  //   procurementId: '',
  //   hpsRequestDate: '',
  //   userIdamanId: '',
  //   hpsStatus: '',
  //   noNotaDinas: '',
  //   id: '',
  // });

  const [form, setForm] = useState({
    procurementNumber: '',
    hpsRequestNumber: '',
    hpsRequestDate: '',
    userIdamanId: '',
    noNotaDinas: '',
    hpsStatus: '',
    hpsStatusCompleted: false,
    id: '',
    procurementId: '',
    productTypeId: '',
    productNameId: '',
    deliveryTerms: '',
    pricingMethod: '',
  });

  useEffect(() => {
    fetchDataProcurement(ids, setForm, token);
  }, [ids]);

  const fetchDataProcurement = async (ids, setForm, token) => {
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });

      const data = response;
      setForm({
        procurementNumber: data.procurementNumber || null,
        hpsRequestNumber: data.hpsRequestNumber || null,
        hpsRequestDate:
          format(
            !data.hpsRequestDate ||
              new Date(data.hpsRequestDate).getTime() === 0
              ? new Date()
              : new Date(data.hpsRequestDate),
            'dd/MM/yyyy'
          ) || null,
        userIdamanId: data.userIdamanId || null,
        noNotaDinas: data.noNotaDinas || null,
        hpsStatus: data.hpsStatus || null,
        hpsStatusCompleted: data.hpsStatus === 2 ? true : false,
        id: data.id || null,
      });
    } catch (error) {
      console.error('Error fetching data from  API:', error);
    }
  };

  const selectedFields = {
    procurementId: form.id,
    hpsRequestDate: convertToInputDateFormat(form.hpsRequestDate),
    userIdamanId: form.userIdamanId,
    noNotaDinas: form.noNotaDinas,
  };

  const handleSaveHPSrequest = async e => {
    console.log('simpan', selectedFields);
    // if (validatedeliveryModal()) {
    try {
      const response = await axios.put(
        `${api.API_URL}/hps/${ids}`,
        selectedFields,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      notify.success(MESSAGES.saved);
      LoadDefault();
    }
    // }
  };

  const handleChange = e => {
    const input = e.target.value;
    if (isNumericOnly(input)) {
      setValue(input === '' ? '0' : input);
    }
  };

  function handleSelectCountry(selectedCountry) {
    setselectedCountry(selectedCountry);
  }

  function handleSelectState(selectedState) {
    setselectedState(selectedState);
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  const validatedeliveryModal = () => {
    let tempErrors = {};

    if (!form.productTypeId) {
      tempErrors.productTypeId = 'Please Select';
    }

    if (!form.productNameId) {
      tempErrors.productNameId = 'Please Select';
    }

    if (Object.keys(tempErrors).length !== 0) {
      notify.warning(MESSAGES.mandatory);
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  useEffect(() => {
    fetchQtyDeliveryList();
  }, [ids]);

  const fetchQtyDeliveryList = async () => {
    if (!ids) {
      return;
    }
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${api.API_URL}/quantity-delivery?ProcurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP error: ${response.status} ${response.statusText}`
        );
      }
      const result = await response.json();
      if (!result.data?.items) {
        console.warn('No items found in response');
        return;
      }
      const items = result.data.items.map(item => ({
        procurementId: item.procurementId,
        ratioLpgId: item.ratioLpgId,
        ratioName: item.ratioLpg?.ratioName ?? null,
        deliveryUnit: item.deliveryUnit,
        frequency: item.frequency,
        pricingPeriod: item.pricingPeriod,
        indexPricename: item.indexPrice?.name ?? null,
        otherIndexPricename: item.otherIndexPrice?.name ?? null,
        startDatePublishIndex: item.startDatePublishIndex,
        endDatePublishIndex: item.endDatePublishIndex,
        schemaBL: item.schemaBL,
        notesForPricing: item.notesForPricing,
        isCorrelationBetweenTwoIndex: item.isCorrelationBetweenTwoIndex,
        id: item.id,
      }));
      setQtyDeliveryData({ items });
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  document.title = `Request HPS - ${form.hpsRequestNumber}`;
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Detail Information' pageTitle='Request HPS' />
          <div className='dt-header__top'>
            <DetailBackButton
              label='Back to list'
              onClick={() => navigate('/apps-requesthps/view')}
            />
          </div>
          <Row className='justify-content-center'>
            <Col xxl={12}>
              <Card>
                <CardBody className='checkout-tab'>
                  <HpsRequestTab
                    ids={ids}
                    form={form}
                    setForm={setForm}
                    errors={errors}
                    error={error}
                    setError={setError}
                    token={token}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    handleSaveHPSrequest={handleSaveHPSrequest}
                    qtyDeliveryData={qtyDeliveryData}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HpsForm;
